<div class="objects-wrap" fxLayout="column" fxLayoutAlign="center center">
  
  <div *ngIf="objectsLoaded && !objects.length">
    This {{ connection ? "connection" : (starch ? "starch" : "") }} has no {{ connection ? "objects" : (starch ? "tables" : "") }}
  </div>

  <div class="search-bar">
    <div fxLayoutAlign="start center">
      <div class="item-title" fxFlex="15" fxLayoutAlign="start center">Objects</div>
      <mat-form-field *ngIf="objects?.length > 10" fxFlex="85" appearance="outline" style="margin-bottom: -1.25em;">
        <mat-label>Search for objects</mat-label>
        <input matInput (input)="searchObjects($event)">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <spinner *ngIf="spinner" selfSpin="true"></spinner>  

  <div style="height: 1rem;"></div>

  <div 
    class="object-items-wrap"
    fxLayout="row wrap" fxLayoutAlign="start center" 
    *ngIf="objects.length"
  >
    <!-- <mat-chip-set>
      <ng-container *ngFor="let object of filteredObjects; trackBy: trackByFn">
        <mat-chip 
          class="chip-item" 
          [matTooltip]="object.type !== '__SPECIAL__' ? 'Explore ' + object.name : ''"
          (click)="exploreObject(object.__id)"
        >
          <div fxLayout="row">
            <span class="button-text" [class.special-chip]="object.type === '__SPECIAL__'">{{ object.name }}</span>
            <mat-icon *ngIf="object.type !== '__SPECIAL__'">chevron_right</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
    </mat-chip-set> -->

    <app-list-panel 
        *ngIf="filteredObjects.length"
        [panelMeta]="listPanelMeta" 
        [inputData]="filteredObjects" 
        [builderMode]="false"
        (rowData)="rowClicked($event)"
    ></app-list-panel>
  </div>

</div>